import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-10",
  "use": "icon-icon-nav-10-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-10\"><path d=\"M512 832l-50.56-46.08C281.792 623.168 163.2 515.712 163.2 383.872A189.952 189.952 0 0 1 355.072 192C415.744 192 473.984 220.224 512 264.896A208.832 208.832 0 0 1 668.928 192a189.952 189.952 0 0 1 191.872 191.808c0 131.84-118.592 239.296-298.24 402.56L512 832z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-10.svg
// module id = PZsG
// module chunks = 3